import { BidType, MarketProgram } from '@/features/bidding/constants'

/**
 * Slug helpers for the new bid detail route `/bidding/:marketProgram/:bidType`.
 *
 * `:marketProgram` and `:bidType` URL params use kebab-lowercase slugs
 * (e.g. `mfrr-down`, `energy`) for readability. The API uses uppercase enums
 * (`MFRR_DOWN`, `ENERGY`). These helpers map between the two and validate the
 * input.
 */

export type MarketProgramSlug = string
export type BidTypeSlug = 'capacity' | 'energy'

export function marketProgramToSlug(marketProgram: MarketProgram): MarketProgramSlug {
  return marketProgram.toLowerCase().replaceAll('_', '-')
}

export function marketProgramFromSlug(slug: string): MarketProgram | null {
  const candidate = slug.toUpperCase().replaceAll('-', '_')

  if (isMarketProgram(candidate)) {
    return candidate
  }

  return null
}

export function bidTypeToSlug(bidType: BidType): BidTypeSlug {
  return bidType.toLowerCase() as BidTypeSlug
}

export function bidTypeFromSlug(slug: string): BidType | null {
  const candidate = slug.toUpperCase()

  if (isBidType(candidate)) {
    return candidate
  }

  return null
}

function isMarketProgram(value: string): value is MarketProgram {
  return Object.values<string>(MarketProgram).includes(value)
}

function isBidType(value: string): value is BidType {
  return Object.values<string>(BidType).includes(value)
}
